import { createSocialPresentation } from '../../../renderer/src/social-presentation';
import type { VideoPreference } from './video-presentation-preferences';

/** Upgrade editing preferences while leaving stored render jobs unchanged. */
export function compactLandscapePreference(value: VideoPreference): VideoPreference {
  if (value.preset !== 'landscape-16x9' || value.presentation.version !== 1) return value;
  const previous = value.presentation;
  return { ...value, presentation: { ...createSocialPresentation('none', 'top-title'),
    titleSize: Math.round(44 * previous.titleScale / 100),
    statisticsSize: Math.round(30 * previous.statisticsScale / 100),
    showTotals: previous.showTotals, showElevation: previous.showElevation,
    ...(previous.plateTransparency === undefined ? {} : { plateTransparency: previous.plateTransparency }),
    ...(previous.textColor === undefined ? {} : { textColor: previous.textColor }) } };
}
